import { ref, watch, computed } from '@vue/composition-api'

import useJwt from "@/auth/jwt/useJwt";
import CISSettingService from '@/services/cis-setting.service'
import CategoryService from "@/services/category.service";

import store from "@/store";

export default function cisUncategorizedList() {
  const refUncategorizedTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'uncatKeywords', label: 'uncategorized', sortable: false },
    { key: 'relKeywords', label: 'related keywords', sortable: false },
    { key: 'cnt', label: 'count', sortable: true },
    { key: 'actions', sortable: false },
  ]

  const category = ref('Unknown')
  const perPage = ref(10)
  const totalUncategorized = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const listCtgSq = ref(1)

  const dataMeta = computed(() => {
    const localItemsCount = refUncategorizedTable.value ? refUncategorizedTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUncategorized.value,
    }
  })

  const reFetchData = () => {
    refUncategorizedTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter, category], () => {
    console.log('---------- watch js ----------')
    console.log(category.value)

    if (category.value !== 'Unknown' && category.value !== '9999')
      reFetchData()
  })

  const fetchUncategorized = async (ctx, callback) => {
    console.log('---------- fetchUncategorized ----------')
    console.log(category.value)
    console.log(listCtgSq.value)

    if (category.value === 'Unknown')
      return;

    CISSettingService.uncategorizedList({
      category: category.value,
      search: searchQuery.value,
      pageNumber: currentPage.value - 1,
      pageSize: perPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      ctgSq: listCtgSq.value
    }).then(response => {
      if (response && response.data.success) {
        const { data, total } = response.data

        for (const item of data) {
            var split = item.relKeywords.split(',');

            if (split.length > 5)
                item.relKeywords = split.slice(0, 5).join(', ') + '...'
            else
                item.relKeywords = split.join(', ')
        }

        callback(data)
        totalUncategorized.value = total
      }
    })
  }

  return {
    category,

    fetchUncategorized,
    tableColumns,
    perPage,
    currentPage,
    totalUncategorized,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUncategorizedTable,

    statusFilter,

    reFetchData,
    listCtgSq
  }
}
